import { get } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { pullThumbnailRequestAction } from 'common/actions';
import { Button } from 'components/button';
import { resetDialogAction, showDialogAction } from 'components/redux-dialog/actions';
import { dialogSelector } from 'components/redux-dialog/selectors';
import { CurrentThumbnail } from './fragments/current-thumbnail';
import { NewThumbnail } from './fragments/new-thumbnail';

export const GENERATE_THUMBNAIL_DIALOG = 'generate_thumbnail_dialog';

const mapDispatchToProps = (dispatch) => ({
  showThumbnailDialog: () => dispatch(showDialogAction(GENERATE_THUMBNAIL_DIALOG)),

  resetDialog: () => dispatch(resetDialogAction(GENERATE_THUMBNAIL_DIALOG)),

  pullThumbnail: (videoId, thumbnailId) => dispatch(pullThumbnailRequestAction(videoId, thumbnailId)),
});

const mapStateToProps = (state) => ({
  dialog: dialogSelector(state)(GENERATE_THUMBNAIL_DIALOG),
});

const Thumbnail = (props) => {
  const { t, showThumbnailDialog, video, dialog, pullThumbnail, resetDialog } = props;
  const [newThumbId, setNewThumbId] = useState();
  const [newThumbUrl, setNewThumbUrl] = useState();

  useEffect(() => {
    const id = get(dialog.data, 'id');
    const url = get(dialog.data, 'url');

    if (id && !url) {
      const interval = setInterval(() => {
        pullThumbnail(video.id, id);
      }, 1500);
      return () => {
        clearInterval(interval);
        resetDialog();
      };
    } else if (id && url) {
      setNewThumbId(id);
      setNewThumbUrl(url);
    }
  }, [dialog.data, video.id, pullThumbnail, resetDialog]);

  return (
    <React.Fragment>
      <div className="form-group ct-thumbnail-form-field">
        <label className="label">{t('thumbnail')}</label>

        <div className="ct-thumbnail-form-field__wrapper">
          <NewThumbnail newThumbId={newThumbId} newThumbUrl={newThumbUrl} />
          <CurrentThumbnail newThumbId={newThumbId} videoThumbnailUrl={get(video, 'thumbnail.url')} />
        </div>
      </div>

      <Button onClick={showThumbnailDialog} secondary>
        {t('create_new_thumbnail')}
      </Button>
    </React.Fragment>
  );
};

export const ThumbnailDecorated = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(Thumbnail);

ThumbnailDecorated.propTypes = {
  video: PropTypes.any.isRequired,
};

export * from './generate-thumbnail.dialog';
